// extracted by mini-css-extract-plugin
module.exports = {"innerPageContent":"SingleContainerPro_innerPageContent__1ult4","projectList":"SingleContainerPro_projectList__1C5s-","fieldSpace":"SingleContainerPro_fieldSpace__-fg9x"};